import { guessLocale, splitLocale, stripUniversalPrefix, } from '@tymia/main-api';
import { omit, } from 'remeda';
import { api, } from '../../api/Api.js';
import { router, waitForRouterSettled, } from '../../router/router.js';
import { createOverridableChannelStore, } from '../../utils/OverridableChannelStore.js';
export const configStore = createOverridableChannelStore({
    name: `config-store-${process.env.RELEASE_VERSION}`,
    initial: {
        state: 'uninitialized',
    },
});
export function setConfig(config) {
    const locale = guessLocale(config.principal.locale);
    configStore.set({
        ...omit(config, ['status']),
        principal: {
            ...config.principal,
            locale,
        },
        state: 'initialized',
    });
    return {
        locale,
    };
}
let previousLocale;
async function handleStateChange(status, state) {
    if (status !== 'ready') {
        return;
    }
    if (state.state === 'error') {
        console.error('Error loading config', state.error);
        return;
    }
    const veryFirstCall = state.state === 'uninitialized';
    if (veryFirstCall) {
        try {
            const localeFromUrl = splitLocale(stripUniversalPrefix(new URL(window.location.href)).pathname).locale;
            const response = await api.common.config.request({
                urlLocale: localeFromUrl,
            });
            if (response.status !== 'ok') {
                throw new Error(`Error ${response.httpStatus}: ${response.message}`);
            }
            const { locale } = setConfig(response);
            previousLocale = locale;
        }
        catch (error) {
            configStore.setLocal({
                state: 'error',
                error: error instanceof Error ? error : new Error(String(error)),
            });
        }
        return;
    }
    if (previousLocale && previousLocale !== state.principal.locale) {
        const currentRouter = router();
        if (await waitForRouterSettled(currentRouter) === false) {
            console.error('Router did not settle within the timeout');
        }
        const match = currentRouter.state.matches.at(-1);
        if (match) {
            // eslint-disable-next-line require-atomic-updates
            previousLocale = state.principal.locale;
            return currentRouter.navigate({
                to: currentRouter.routesById[match.routeId].to,
                params: match.params,
                search: match.search,
                resetScroll: false,
            });
        }
    }
    if (previousLocale === undefined) {
        previousLocale = state.principal.locale;
    }
}
configStore.subscribeStatus(async (status) => {
    await handleStateChange(status, configStore.get());
});
configStore.subscribe(async (state) => {
    await handleStateChange(configStore.status, state);
});
//# sourceMappingURL=ConfigStore.js.map